import {trackEvent} from '@hconnect/common/logging/Analytics'
import {QueryFunction, useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {api} from '../../../../../App.store'
import {CustomerTierSettings} from '../types/CustomerTierSettings'

import {CustomerTierSettingsQueryKey, ProductConfigsQueryKey} from './queryKeys'

const customerTierSettingsFetcher: QueryFunction<CustomerTierSettings[]> = async () => {
  const response = await api.get<CustomerTierSettings[]>('/product-configs/customerTierSettings')
  return response.data
}

export const useCustomerTierSettingsQuery = () => {
  return useQuery<CustomerTierSettings[], AxiosError>(
    [ProductConfigsQueryKey, CustomerTierSettingsQueryKey],
    customerTierSettingsFetcher,
    {
      onError: (error) => {
        console.error(error)
        trackEvent('adminConsoleError', {
          product: 'adminConsole',
          date: new Date().toISOString(),
          errorCode: error.response?.status,
          component: 'useCustomerTierSettingsQuery',
          endpoint: '/product-configs/customerTierSettings'
        })
      }
    }
  )
}
